import {Component, Input, OnInit} from '@angular/core';
import {Detalhamento} from '../detalhamento';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RdsModalComponent} from '../../../shared/rds/rds-modal.component';

@Component({
    selector: 'store-perguntas',
    templateUrl: './perguntas.component.html',
    styleUrls: ['./perguntas.component.scss']
})
export class PerguntasComponent implements OnInit {

    @Input()
    public detalhamento: Detalhamento;

    constructor(private modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.detalhamento.perguntasFrequentes.map(pergunta => pergunta.isCollapsed = true);
    }

    solicitarDemonstracao(): void {
        this.modalService.open(RdsModalComponent);
    }

}
